import { createSlice } from '@reduxjs/toolkit';

const confirmSlice = createSlice({
  name: 'confirm',
  initialState: {
    isShow: false,
    message: [],
    callback: () => {},
    cancelCallback: () => {},
  },
  reducers: {
    open: (state, { payload: { message, callback, cancelCallback } }) => {
      state.isShow = true;
      state.message = message;
      state.callback = callback || (() => {});
      state.cancelCallback = cancelCallback || (() => {});
    },
    close: state => {
      state.isShow = false;
    },
  },
});

export const { open, close } = confirmSlice.actions;
export default confirmSlice.reducer;
